import React from 'react';
import { Globe, Mail, Instagram, MessageCircle } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const {
    lang
  } = useLanguage();
  const navLinks = [{
    label: lang === 'es' ? 'Inicio' : 'Home',
    href: '#inicio'
  }, {
    label: lang === 'es' ? 'Servicios' : 'Services',
    href: '#servicios'
  }, {
    label: lang === 'es' ? 'Portafolio' : 'Portfolio',
    href: '#portafolio'
  }, {
    label: lang === 'es' ? 'Sobre mí' : 'About me',
    href: '#sobre'
  }, {
    label: 'FAQ',
    href: '#faq'
  }, {
    label: lang === 'es' ? 'Contacto' : 'Contact',
    href: '#contacto'
  }];
  return <footer className="bg-inkova-dark pt-16 pb-8 text-white/70" data-id="element-161" data-mp="3qc3z32pyhkhf">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162" data-mp="29ynldknsn5e0">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr] gap-12 lg:gap-16 mb-12" data-id="element-163" data-mp="2a19qzer4jatl">
          {/* Brand */}
          <div data-id="element-164" data-mp="3l90l3octskvk">
            <div className="flex items-center gap-3 mb-4" data-id="element-165" data-mp="3lalgthavm9v0">
              <img src="https://cdn.magicpatterns.com/uploads/owVcxkWT6ABhGYw2qQLWVA/INK_PNG.png" alt="Inkova Creation" className="h-9 w-auto block brightness-0 invert" data-id="element-166" data-mp="3gagzjp259b3q" />
              <div className="flex flex-col" data-id="element-167" data-mp="3q8di31xev8bv">
                <span className="text-[11px] text-white" data-id="element-168" data-mp="3qaq17iewnoqi">
                  Business Consulting & Creation
                </span>
              </div>
            </div>
            <p className="text-sm text-white leading-[1.7] max-w-[300px] mb-5" data-id="element-169" data-mp="335slg3f1hfy">
              {lang === 'es' ? 'Tu negocio digital construido desde tu identidad y propósito. Miami, Florida.' : 'Your digital business built from your identity and purpose. Miami, Florida.'}
            </p>
            <div className="text-[13px] space-y-2" data-id="element-170" data-mp="qtrpqcbvthb6">
              <div className="flex items-center gap-2" data-id="element-171" data-mp="msg5ynfovqaw">
                <Globe className="w-4 h-4 text-inkova-accent shrink-0" strokeWidth={1.5} data-id="element-172" data-mp="mptqm1mk46i4" />
                <a href="https://inkovacreation.com" className="text-white hover:opacity-70 transition-opacity" data-id="element-173" data-mp="yto69tsjfzt5">
                  inkovacreation.com
                </a>
              </div>
              <div className="flex items-center gap-2" data-id="element-174" data-mp="18lbuzmxpn2qx">
                <Mail className="w-4 h-4 text-inkova-accent shrink-0" strokeWidth={1.5} data-id="element-175" data-mp="1cm484r9pdrsh" />
                <a href="mailto:info@inkovacreation.com" className="text-white hover:opacity-70 transition-opacity" data-id="element-176" data-mp="1hiukb3ie038m">
                  info@inkovacreation.com
                </a>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div data-id="element-177" data-mp="3od85zdkl26mi">
            <h4 className="text-white text-[13px] font-semibold tracking-[1px] uppercase mb-5" data-id="element-178" data-mp="3ta8bnndit7d3">
              {lang === 'es' ? 'Navegación' : 'Navigation'}
            </h4>
            <ul className="flex flex-col gap-3" data-id="element-179" data-mp="2agey3ug4ajcu">
              {navLinks.map((link, index) => <li key={index} data-id="element-180" data-mp="25n3ue26lqip5" data-mpi={index}>
                  <a href={link.href} className="text-sm hover:text-inkova-accent transition-colors duration-200" data-id="element-181" data-mp="21mk0r8l8lx7r">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Social */}
          <div data-id="element-182" data-mp="2pc4m1y4v56k7">
            <h4 className="text-white text-[13px] font-semibold tracking-[1px] uppercase mb-5" data-id="element-183" data-mp="2pdpeni7mafff">
              {lang === 'es' ? 'Síguenos' : 'Follow us'}
            </h4>
            <div className="flex flex-col gap-3" data-id="element-184" data-mp="2feq6s1uoenth">
              <a href="https://instagram.com/inkovacreation" target="_blank" rel="noopener noreferrer" className="text-sm flex items-center gap-2.5 hover:text-inkova-accent transition-colors duration-200" data-id="element-185" data-mp="2fdymhn6j4cii">
                <Instagram className="w-4 h-4 shrink-0" strokeWidth={1.5} data-id="element-186" data-mp="2ru6eruwjbfk4" />
                @inkovacreation
              </a>
              <a href="https://wa.me/13054781618" target="_blank" rel="noopener noreferrer" className="text-sm flex items-center gap-2.5 hover:text-inkova-accent transition-colors duration-200" data-id="element-187" data-mp="2woalcd1w1lko">
                <MessageCircle className="w-4 h-4 shrink-0" strokeWidth={1.5} data-id="element-188" data-mp="3bk8c1ft1lxpi" />
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-7 flex flex-col sm:flex-row justify-between items-center gap-4 text-center sm:text-left" data-id="element-189" data-mp="31krbtdwk8c0x">
          <p className="text-[13px]" data-id="element-190" data-mp="1q6dny91t3wkw">
            {lang === 'es' ? '© 2026 Inkova Creation. Todos los derechos reservados.' : '© 2026 Inkova Creation. All rights reserved.'}
          </p>
          <p className="text-xs" data-id="element-191" data-mp="1nlpjutnet7r5">
            {lang === 'es' ? 'Diseñado con propósito · Miami, Florida 🌴' : 'Designed with purpose · Miami, Florida 🌴'}
          </p>
        </div>
      </div>
    </footer>;
}